// Google Analytics 4 工具类
// 用于管理所有的统计事件和用户行为追踪

class Analytics {
  constructor() {
    this.measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;
    this.isInitialized = false;
  }

  // 初始化GA4
  init() {
    if (!this.measurementId) {
      console.warn('GA4 Measurement ID not found');
      return;
    }

    // 加载GA4脚本
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${this.measurementId}`;
    document.head.appendChild(script);

    // 初始化gtag
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    window.gtag = gtag;
    gtag('js', new Date());
    gtag('config', this.measurementId, {
      page_title: document.title,
      page_location: window.location.href,
    });

    this.isInitialized = true;
    console.log('GA4 initialized successfully');
  }

  // 页面浏览事件
  pageView(pageName, pageTitle) {
    if (!this.isInitialized) return;
    
    gtag('event', 'page_view', {
      page_title: pageTitle || document.title,
      page_location: window.location.href,
      page_name: pageName,
    });
  }

  // 计算器使用事件
  calculatorUsed(calculatorType, action = 'used') {
    if (!this.isInitialized) return;
    
    gtag('event', 'calculator_interaction', {
      calculator_type: calculatorType,
      action: action,
      event_category: 'Calculator',
      event_label: `${calculatorType}_${action}`,
    });
  }

  // 产品比较事件
  productComparison(action, productCount = 0) {
    if (!this.isInitialized) return;
    
    gtag('event', 'product_comparison', {
      action: action,
      product_count: productCount,
      event_category: 'Product',
      event_label: `comparison_${action}`,
    });
  }

  // 产品详情页访问
  productDetailView(productId, productName) {
    if (!this.isInitialized) return;
    
    gtag('event', 'product_detail_view', {
      product_id: productId,
      product_name: productName,
      event_category: 'Product',
      event_label: `detail_${productId}`,
    });
  }

  // 用户交互事件
  userInteraction(action, category, label) {
    if (!this.isInitialized) return;
    
    gtag('event', 'user_interaction', {
      action: action,
      event_category: category,
      event_label: label,
    });
  }

  // 搜索事件
  search(searchTerm, resultsCount = 0) {
    if (!this.isInitialized) return;
    
    gtag('event', 'search', {
      search_term: searchTerm,
      results_count: resultsCount,
      event_category: 'Search',
    });
  }

  // 错误事件
  error(errorType, errorMessage) {
    if (!this.isInitialized) return;
    
    gtag('event', 'exception', {
      description: errorMessage,
      fatal: false,
      event_category: 'Error',
      event_label: errorType,
    });
  }

  // 自定义事件
  customEvent(eventName, parameters = {}) {
    if (!this.isInitialized) return;
    
    gtag('event', eventName, {
      ...parameters,
      event_category: parameters.category || 'Custom',
    });
  }
}

// 创建全局实例
const analytics = new Analytics();

export default analytics;
